import Readmore from 'readmore-js';
(function ($) {
  const behavior = 'polyu_theme.rank-grid';
  Drupal.behaviors[behavior] = {
    attach: (context, settings) => {
      $('.about-programme-container', context).once('polyu_programme_page_accordian').each(function() {
        let readMoreText = 'Read More';
        let readLessText = 'Read Less';

        if ($('.page--node--prog-detail-jee').length > 0) {
          readMoreText = '阅读更多';
          readLessText = '缩小';
        };
        new Readmore('.text-container-student-message .readmore-student-message', {
          speed: 75,
          collapsedHeight: 160,
          heightMargin: 32,
          moreLink: '<a class="morelink" href="#">' + readMoreText + ' </a>',
          lessLink: '<a class="lesslink" href="#">' + readLessText + '</a>',
          embedCSS: false,
        });
      });
    }

  };
})(jQuery);
